module.exports = __webpack_public_path__ + "img/T924.59c46403.jpg";